// Generated from the maintained backend BillingPolicySchema check catalogue.
export const checkCatalogue: Array<{ id: string; version: string; inputFields: string[] }> = [
    {
        "id": "ro-cui",
        "version": "1",
        "inputFields": [
            "taxCountryCode",
            "taxId"
        ]
    },
    {
        "id": "anaf-business",
        "version": "1",
        "inputFields": [
            "taxCountryCode",
            "taxId"
        ]
    },
    {
        "id": "manual-business",
        "version": "1",
        "inputFields": [
            "taxCountryCode",
            "taxId",
            "name"
        ]
    }
];
